import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ title, description, keywords, image, url, schema }) => {
  const isExact = title && title.includes('|') && title.length > 30;
  const metaTitle = title ? (isExact ? title : `${title} | Nathnagri Temples`) : 'Nathnagri Temples of Bareilly - A Spiritual Journey';
  
  const metaDescription = description || 'Discover the divine spiritual history of the Nathnagri Temples of Bareilly. Explore deep culture, traditions, and divine pilgrimage.';
  const metaKeywords = keywords || 'temples, bareilly, nathnagri, shiva, alakhnath, trivatinath, spiritual, pilgrimage, hinduism';
  
  const canonicalUrl = url || (typeof window !== 'undefined' ? window.location.href : 'https://nathnagribareilly.com');
  
  let finalCanonical = canonicalUrl;
  try {
    const urlObj = new URL(canonicalUrl);
    // Remove query parameters to ensure canonical URLs are always clean for SEO
    finalCanonical = `https://nathnagribareilly.com${urlObj.pathname}`;
  } catch (e) {
    // Ignore error
  }

  // Publisher Schema
  const publisherSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Nathnagri Bareilly",
    "url": "https://nathnagribareilly.com",
    "logo": "https://nathnagribareilly.com/images/nathnagri-bareilly-logo.png"
  };

  let schemasToRender = [publisherSchema];
  if (schema) {
    if (Array.isArray(schema)) {
      schemasToRender = [...schemasToRender, ...schema];
    } else {
      schemasToRender.push(schema);
    }
  }

  return (
    <Helmet>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Nathnagri Bareilly" />
      <meta name="publisher" content="Nathnagri Bareilly" />
      
      <link rel="canonical" href={finalCanonical} />
      
      <meta property="og:site_name" content="Nath Nagri Bareilly" />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      {image && <meta property="og:image" content={image} />}
      <meta property="og:url" content={finalCanonical} />
      <meta property="og:type" content="website" />
      
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      {image && <meta name="twitter:image" content={image} />}

      {schemasToRender.map((schemaObj, index) => (
        <script type="application/ld+json" key={index}>
          {JSON.stringify(schemaObj)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;

